import { render, staticRenderFns } from "./tacs.vue?vue&type=template&id=6acea82d&scoped=true&lang=pug&"
import script from "./tacs.vue?vue&type=script&lang=js&"
export * from "./tacs.vue?vue&type=script&lang=js&"
import style0 from "./tacs.vue?vue&type=style&index=0&id=6acea82d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acea82d",
  null
  
)

export default component.exports